<!-- 商品列表组件 -->
<template>
  <div class="container">
    <div class="main">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.goodId">
          <div class="cover">
            <img class="cover-pic" :src="item.icon" alt="" :data-coverroute="item.iconRoute ? item.iconRoute : ''" :data-type="item.type" @click="goDetail">
          </div>
          <div class="main-box">
            <div class="main-title">{{item.name}}</div>
            <div class="main-price-box">
              <div class="main-price-origin">原价：<span>{{item.priceLabel}}元</span></div>
              <div class="main-price">券后价：{{item.discountPriceLabel}}元</div>
            </div>
          </div>
          <div class="buy-btn" :data-goodid="item.goodId" @click="goPurchase">立即购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/config'

export default {
  name: 'GoodsList',
  props: ['list'],
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    goDetail(e) {
      switch (e.target.dataset.type) {
        case 'audio':
          if (e.target.dataset.coverroute) window.location.href = e.target.dataset.coverroute
          break
        case 'vip':
          var encodeUrl = encodeURIComponent(`${config.ilistenRoot}/vip/vipPage`)
          window.location.href = `ilisten:///webopen?pos=in&url=${encodeUrl}&login=0&fullscreen=0`
          break
        case 'pkg':
          if (e.target.dataset.coverroute) window.location.href = e.target.dataset.coverroute
          break
      }
    },

    goPurchase (e) {
      console.log(`ilisten:///order/payment?id=${e.target.dataset.goodid}&couponid=${this.$route.query.couponid}`)
      window.location.href = `ilisten:///order/payment?id=${e.target.dataset.goodid}&couponid=${this.$route.query.couponid}`
    }
  },
  mounted() {
    
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.main {
  padding: 0 .36rem;
}

.list {
  height: 100%;
  .item {
    position: relative;
    display: flex;
    padding: .32rem 0;
    height: 2.81rem;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
}

.cover {
  display: flex;
  align-items: center;
  width: 2.02rem;
  .cover-pic {
    display: block;
    width: 2.02rem;
    height: 2.02rem;
    box-sizing: border-box;
    border-radius: 6px;
  }
}
.main-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: .08rem 0 .08rem .18rem;
  height: 100%;
  .main-title {
    display: -webkit-box;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #6c6c73;
    font-weight: bold;
    font-size: .32rem;
  }
  .main-price-origin {
    color: #c4c4c6;
    font-size: .28rem;
    span {
      text-decoration: line-through;
    }
  }
  .main-price {
    margin-top: .06rem;
    color: #fcac00;
    font-size: .34rem;
    font-weight: bold;
  }
}
.buy-btn {
  position: absolute;
  display: block;
  right: 0;
  bottom: .32rem;
  width: 1.56rem;
  height: .7rem;
  line-height: .7rem;
  text-align: center;
  color: #604038;
  font-size: .26rem;
  font-weight: bold;
  border-radius: 200px;
  background: linear-gradient(134deg, #f8dd61, #feb800)
}

</style>
